import { render, staticRenderFns } from "./AddressLabel.vue?vue&type=template&id=1cc4cd8a&scoped=true"
import script from "./AddressLabel.vue?vue&type=script&lang=js"
export * from "./AddressLabel.vue?vue&type=script&lang=js"
import style0 from "./AddressLabel.vue?vue&type=style&index=0&id=1cc4cd8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc4cd8a",
  null
  
)

export default component.exports